import gql from 'graphql-tag';

const getCompaniesSlimQuery = gql`
  {
    companiesSlim {
      name
      _id
      logo
      whatsappLink
      slackLink
      services {
        _id
      }
      masterCode
      emailSuffix
      needsHealthDeclaration
      contentEnabled
      competitionMode
      leaderboardAvailable
      isPublic
      isPhoneOptional
      isIdRequired
      allow_gym_subscription
      sites
      minCancellationHours
      cancellationCustomMessage
      promotions {
        _id
      }
    }
  }
`;

export default getCompaniesSlimQuery;
